import React from 'react'
import styled from 'styled-components'

import { CellSize, labels } from '../types/common'

interface IProps {}

const cellLabels = [
  {
    label: labels.player,
    size: CellSize.MEDIUM,
  },
  {
    label: labels.country,
    size: CellSize.MEDIUM,
  },
  {
    label: labels.positions,
    size: CellSize.MEDIUM,
  },
  {
    label: labels.strongFoot,
    size: CellSize.MEDIUM,
  },
  {
    label: labels.height,
    size: CellSize.SMALL,
  },
  {
    label: labels.yearStart,
    size: CellSize.SMALL,
  },
  {
    label: labels.inActivity,
    size: CellSize.SMALL,
  },
  {
    label: labels.clubs,
    size: CellSize.LARGE,
  },
  {
    label: labels.goalsCount,
    size: CellSize.SMALL,
  },
  {
    label: labels.championshipTitlesCount,
    size: CellSize.SMALL,
  },
  {
    label: labels.cupTitlesCount,
    size: CellSize.SMALL,
  },
  {
    label: labels.selectionsCount,
    size: CellSize.SMALL,
  },
]

export default function ResultLabels(props: IProps) {
  return (
    <Container>
      {cellLabels.map((cell, index) => (
        <CellContainer key={index} size={cell.size}>
          <p>{cell.label}</p>
        </CellContainer>
      ))}
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 96px;
  justify-content: flex-start;
`

const CellContainer = styled.div<{ size: CellSize }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: flex-end;
  position: relative;
  height: 100%;
  padding: 8px;
  width: ${({ size }) => {
    if (size === CellSize.LARGE) return '240px'
    if (size === CellSize.MEDIUM) return '160px'

    return '96px'
  }};

  & > p {
    font-size: 14px;
    text-align: center;
  }
`
